<template>
  <div id="notfound">
    <h1>お探しのページは見つかりませんでした。</h1>
    <p>
      こちらのURLのページは存在しない、もしくは公開されていません。<br>
      <router-link to="/">ホームへ</router-link>
    </p>
  </div>
</template>

<script>
    export default {
        name: "notfound",
        title: '404',
    }
</script>

<style lang="scss" scoped>
  #notfound{
    font-family: sans-serif, "游ゴシック体", YuGothic,"游ゴシック", "Yu Gothic";
    text-align: center;
    margin-top: 20vh;
    h1{
      font-weight: bold;
      font-size: 2em;
      line-height: 3em;
    }
    p{
      line-height: 2em;
      :link, :visited{
        color: #ed7700;
      }
    }
  }
</style>